/**
 * @file
 * A JavaScript file for the subtheme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function($) {
  "use strict";

  // find div's with class = accordion and turn them in to accordions
  var $accordions = $('div.accordion').each(function(){
    $(this).find('h3').first().addClass('accordion-header');
    $(this).children().not('.accordion-header').wrapAll('<div class="accordion-content"></div>');
  });

  // close the accordions
  $('.accordion-content').hide();

  // make the accordions work
  $('.accordion-header').click(function(){
    $(this).toggleClass('open');
    $(this).siblings('.accordion-content').slideToggle();
  });

})(jQuery);
